module.exports = __webpack_public_path__ + "static/kvm_10.62f5d580.jpg";